export default [{
  path: '/',
  component: () => import('@/views/main'),
  redirect: '/dailyHot/index',
  children: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/monetizationIdea/:menuKey(.*)*',
      name: 'monetizationIdea',
      component: () => import('@/views/monetizationIdea/index'),
      meta: {
        title: '变现思路'
      }
    },
    {
      path: '/miniMall/product',
      name: 'miniMallProduct',
      component: () => import('@/views/miniMall/product/index'),
      meta: {
        title: '商城商品管理'
      }
    },
    {
      path: '/miniMall/aiapp',
      name: 'miniMallAiapp',
      component: () => import('@/views/miniMall/aiapp/index'),
      meta: {
        title: 'AI 小应用管理'
      }
    },
    {
      path: '/system/monetizationContent',
      name: 'monetizationContentManagement',
      component: () => import('@/views/system/monetizationContent/index'),
      meta: {
        title: '变现内容管理'
      }
    },
    {
      path: '/pipLine/square',
      name: 'agentSquare',
      component: () => import('@/views/pipLine/square'),
      meta: {
        title: '工作流广场'
      }
    },
    {
      path: '/pipLine/list',
      name: 'workflowList',
      component: () => import('@/views/pipLine/list'),
      meta: {
        title: '工作流'
      }
    },
    {
      path: '/agent/chat-agent',
      name: 'chatAgentList',
      component: () => import('@/views/chatAgent/index'),
      meta: {
        title: '智能体'
      }
    },
    {
      path: '/agent/chat-agent/edit/:id?',
      name: 'chatAgentEdit',
      component: () => import('@/views/chatAgent/edit'),
      meta: {
        title: '智能体编辑'
      }
    },
    {
      path: '/content/textCheckLibrary',
      name: 'textCheckLibrary',
      component: () => import('@/views/content/textCheckLibrary'),
      meta: {
        title: '图文审核库'
      }
    },
    {
      path: '/content/textLibrary',
      name: 'textLibrary',
      component: () => import('@/views/content/textLibrary'),
      meta: {
        title: '创作图文库'
      }
    },
    {
      path: '/content/coverLibrary',
      name: 'coverLibrary',
      component: () => import('@/views/content/coverLibrary'),
      meta: {
        title: '图片库'
      }
    },
    {
      path: '/content/contentImageLibrary',
      name: 'contentImageLibrary',
      component: () => import('@/views/content/contentImageLibrary'),
      meta: { title: '内容配图库' }
    },
    {
      path: '/aiModel/styleProfile',
      name: 'contentStyleProfile',
      component: () => import('@/views/content/styleProfile'),
      meta: {
        title: '内容风格库'
      }
    },
    {
      path: 'skillPackage',
      name: 'skillPackage',
      component: () => import('@/views/content/skillPackage/index.vue'),
      meta: {
        title: 'Skill 库'
      }
    },
    {
      path: '/aiModel/xhsStyle',
      name: 'xhsStyleLibrary',
      component: () => import('@/views/aiModel/xhsStyle/index.vue'),
      meta: {
        title: '小红书样式库'
      }
    },
    {
      path: '/content/favoriteTextLibrary',
      name: 'favoriteTextLibrary',
      component: () => import('@/views/content/textFavoriteLibrary'),
      meta: {
        title: '收藏夹'
      }
    },
    {
      path: '/content/videoCheckLibrary',
      name: 'videoCheckLibrary',
      component: () => import('@/views/content/videoCheckLibrary'),
      meta: {
        title: '视频审核库'
      }
    },
    {
      path: '/content/videoLibrary',
      name: 'videoLibrary',
      component: () => import('@/views/content/videoLibrary'),
      meta: {
        title: '视频内容库'
      }
    },
    {
      path: '/content/bgmLibrary',
      name: 'bgmLibrary',
      component: () => import('@/views/content/bgmLibrary'),
      meta: {
        title: '背景音乐库'
      }
    },
    {
      path: '/category/category',
      name: 'category',
      component: () => import('@/views/distribute/category'),
      meta: {
        title: '分类管理'
      }
    },
    {
      path: '/distribute/history',
      name: 'distributeHistory',
      component: () => import('@/views/distribute/history'),
      meta: {
        title: '分发历史'
      }
    },
    {
      path: '/dailyHot/index',
      name: 'dailyHot',
      component: () => import('@/views/dailyHot/index'),
      meta: {
        title: '今日热榜'
      }
    },
    {
      path: '/aiModel/list',
      name: 'aiModelList',
      component: () => import('@/views/aiModel/list'),
      meta: {
        title: 'AI模型'
      }
    },
    {
      path: '/dashboard/index',
      name: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: {
        title: '数据看板'
      }
    },
    {
      path: '/netdiskManage',
      name: 'netdiskManage',
      component: () => import('@/views/netdisk/manage/index'),
      meta: {
        title: '网盘管理'
      }
    },
    {
      path: '/aiModel/promptTemplate',
      name: 'aiPromptTemplate',
      component: () => import('@/views/aiModel/promptTemplate'),
      meta: {
        title: '提示词模板'
      }
    },
    {
      path: '/system/account',
      name: 'systemAccount',
      component: () => import('@/views/system/account'),
      meta: {
        title: '账号管理'
      }
    },
    {
      path: '/system/menu',
      name: 'systemMenu',
      component: () => import('@/views/system/menu'),
      meta: {
        title: '菜单管理'
      }
    },
    {
      path: '/system/role',
      name: 'systemRole',
      component: () => import('@/views/system/role'),
      meta: {
        title: '角色管理'
      }
    },
    {
      path: '/system/flowItem',
      name: 'systemFlowItem',
      component: () => import('@/views/system/flowItem'),
      meta: {
        title: '工作流插件'
      }
    },
    {
      path: '/system/commonModel',
      name: 'systemCommonModel',
      component: () => import('@/views/system/commonModel'),
      meta: {
        title: '公共AI模型'
      }
    },
    {
      path: '/system/commonAgent',
      name: 'systemCommonAgent',
      component: () => import('@/views/system/commonAgent'),
      meta: { title: '公共智能体' }
    },
    {
      path: '/system/quota',
      name: 'systemQuota',
      component: () => import('@/views/system/quota/index.vue'),
      meta: { title: '算力管理' }
    },
    {
      path: '/system/server',
      name: 'systemServer',
      component: () => import('@/views/system/server'),
      meta: {
        title: '服务器管理'
      }
    },
    {
      path: '/distribute/account',
      name: 'distributeAccount',
      component: () => import('@/views/distribute/account'),
      meta: {
        title: '账号管理'
      }
    },
    {
      path: '/distribute/terminal',
      name: 'distributeTerminal',
      component: () => import('@/views/distribute/terminal/index'),
      meta: {
        title: '分发终端'
      }
    },
    {
      path: '/distribute/product',
      name: 'distributeProduct',
      component: () => import('@/views/distribute/product'),
      meta: {
        title: '商品管理'
      }
    },
    {
      path: '/distribute/apiSetting',
      name: 'apiSetting',
      component: () => import('@/views/distribute/apiSetting'),
      meta: {
        title: 'API接口'
      }
    },
    {
      // MCP 接入页路由统一为 /index 形态(与菜单约定一致);旧路径 redirect 兼容
      path: '/mcp-portal/index',
      name: 'McpPortal',
      component: () => import('@/views/mcpPortal/index.vue'),
      meta: {
        title: 'MCP 接入',
        icon: 'ios-cube'
      }
    },
    {
      path: '/mcp-portal',
      redirect: '/mcp-portal/index'
    },
    {
      path: '/loop-agent',
      name: 'LoopAgent',
      component: () => import('@/views/loopAgent/index.vue'),
      meta: {
        title: 'Loop Agent',
        icon: 'ios-infinite'
      }
    },
    {
      path: '/xianyuAgent/product/index',
      name: 'XianyuProduct',
      component: () => import('@/views/xianyuAgent/product/index.vue'),
      meta: {
        title: '商品库',
        icon: 'md-fish'
      }
    },
    {
      path: '/xianyuAgent/account/index',
      name: 'XianyuAccount',
      component: () => import('@/views/xianyuAgent/account/index.vue'),
      meta: {
        title: '闲鱼账号',
        icon: 'md-person'
      }
    },
    {
      path: '/xianyuAgent/order/index',
      name: 'XianyuOrder',
      component: () => import('@/views/xianyuAgent/order/index.vue'),
      meta: {
        title: '订单与发货',
        icon: 'md-cart'
      }
    },
    {
      path: '/system/wechatMonitor',
      name: 'wechatMonitor',
      component: () => import('@/views/system/wechatMonitor'),
      meta: {
        title: '微信监控账号'
      }
    },
    {
      path: '/pipLine/Log',
      name: 'pipLineLog',
      component: () => import('@/views/pipLine/log'),
      meta: {
        title: '工作流日志'
      }
    },
    {
      path: '/account/info',
      name: 'accountInfo',
      component: () => import('@/views/account'),
      meta: {
        title: '账号信息'
      }
    },
    {
      path: '/content/textCommonLibrary',
      name: 'textCommonLibrary',
      component: () => import('@/views/content/textCommonLibrary'),
      meta: {
        title: '公共图文库'
      }
    },
    {
      path: '/system/riskText',
      name: 'systemRiskText',
      component: () => import('@/views/system/riskText'),
      meta: {
        title: '敏感词库'
      }
    },
    {
      path: '/content/videoAiCut',
      name: 'videoAiCut',
      component: () => import('@/views/content/videoAiCut'),
      meta: {
        title: 'AI剪辑'
      }
    },
    {
      path: '/content/aiVideo',
      name: 'aiVideo',
      component: () => import('@/views/content/aiVideo'),
      meta: {
        title: 'AI视频'
      }
    },
    {
      path: '/distribute/resourceChat',
      name: 'resourceChat',
      component: () => import('@/views/distribute/resourceChat'),
      meta: {
        title: '资源对话'
      }
    },
    {
      path: '/content/publishedTextLibrary',
      name: 'publishedTextLibrary',
      component: () => import('@/views/content/textLibrary'),
      meta: {
        title: '已分发图文库'
      }
    },
    {
      path: '/content/aiProcessTextLibrary',
      name: 'aiProcessTextLibrary',
      component: () => import('@/views/content/textLibrary'),
      meta: {
        title: 'AI已处理库'
      }
    },
    {
      path: '/content/preAiProcessTextLibrary',
      name: 'preAiProcessTextLibrary',
      component: () => import('@/views/content/textLibrary'),
      meta: {
        title: 'AI待处理库'
      }
    },
    {
      path: '/content/prePublishTextLibrary',
      name: 'prePublishTextLibrary',
      component: () => import('@/views/content/textLibrary'),
      meta: {
        title: '已审核待发布库'
      }
    },
    {
      path: '/aiBox/chat',
      name: 'aiBoxChat',
      component: () => import('@/views/aiBox/chat/index.vue'),
      meta: {
        title: 'AI 聊天'
      }
    },
    {
      path: '/aiBox/draw',
      name: 'aiBoxDraw',
      component: () => import('@/views/aiBox/draw/index.vue'),
      meta: {
        title: 'AI 绘画'
      }
    },
    {
      path: '/aiBox/claude-code',
      name: 'aiBoxClaudeCode',
      component: () => import('@/views/aiBox/claudeCode/index.vue'),
      meta: {
        title: 'Claude 终端'
      }
    },
  ]
}]
